import { useDefinition } from "../../../hooks/useDefinition";

export function useMaxTextLength() {
	const definition = useDefinition();

	return definition?.product?.maxTextLength || 0;
}
